module.exports = __webpack_public_path__ + "media/images/logo-b2f164ddd584cc737e3ab35cbae9c36d.svg";